module.exports = __webpack_public_path__ + "img/milestone-last-active.5d2431f2.png";